"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var Button_1 = __importStar(require("@seaweb/coral/components/Button/Button"));
var CancelSmall_1 = __importDefault(require("@seaweb/coral/components/icons/CancelSmall"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var TextFieldContext_1 = require("./TextFieldContext");
var WrappedButton = forwardAs_1.default(Button_1.default);
var StyledButton = styled_1.default(WrappedButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  opacity: 0.3;\n\n  &[data-coral-hover],\n  &:hover {\n    opacity: 1;\n  }\n\n  ", ";\n"], ["\n  margin: 0;\n  opacity: 0.3;\n\n  &[data-coral-hover],\n  &:hover {\n    opacity: 1;\n  }\n\n  ",
    ";\n"])), function (_a) {
    var spacing = _a.theme.spacing;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 ", "px;\n  "], ["\n    padding: 0 ", "px;\n  "])), spacing.factor * 3);
});
var TextFieldClear = react_1.forwardRef(function TextFieldClear(_a, ref) {
    var as = _a.as, onClick = _a.onClick, _b = _a.variant, variant = _b === void 0 ? Button_1.ButtonVariants.Text : _b, colorProp = _a.color, props = __rest(_a, ["as", "onClick", "variant", "color"]);
    var _c = TextFieldContext_1.useTextFieldContext(), length = _c.value.length, inputRef = _c.inputRef;
    var handleClick = useWrapEvent_1.default(onClick, function () {
        var constructor = Object.getPrototypeOf(inputRef.current);
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(constructor, 'value').set;
        nativeInputValueSetter.call(inputRef.current, '');
        var ev = new Event('input', { bubbles: true });
        inputRef.current.dispatchEvent(ev);
        inputRef.current.focus();
    });
    var colors = ThemeProvider_1.useThemeContext().colors;
    var color = fallback_1.default(colorProp, colors.alternate);
    if (!length)
        return null;
    return (react_1.default.createElement(StyledButton, __assign({ _as: as, ref: ref, onClick: handleClick, variant: variant, color: color, "aria-label": "Clear input" }, props),
        react_1.default.createElement(CancelSmall_1.default, { "aria-hidden": true })));
});
exports.default = react_1.memo(TextFieldClear);
var templateObject_1, templateObject_2;
